import { media } from '@atlaskit/primitives/responsive';
import { token } from '@atlaskit/tokens';
import { css } from '@compiled/react';
import { useLoaderData, useParams } from 'react-router-dom';
import { Divider } from '@atlassian/learning-components';

import { useScreenEvent } from 'src/hooks/useScreenEvent';

import { InstructorIntro } from './children/InstructorIntro';
import { UpperSection } from './children/UpperSection';
import { LowerSection } from './children/LowerSection';
import { EnrolledBanner } from './children/EnrolledBanner';
import { RichContent } from '../RichContent';
import { useSessionData } from './useSessionData';
import { ClassPageLoaderProps } from '../classPageLoader';

export const ClassPage = () => {
  const { courseId = '', instanceId = '' } = useParams();
  const { contentfulILTData } = useLoaderData() as ClassPageLoaderProps;
  const { session, enrollBanner, isEnrolled, enrollmentId, tags, otherSessions } = useSessionData(
    courseId,
    instanceId,
    contentfulILTData,
  );

  useScreenEvent({ eventName: 'classPageScreen' });

  const title = contentfulILTData?.courseTitleExternal || '';
  const duration = session.duration;

  return (
    <>
      <div css={headerContainerStyles}>
        <UpperSection title={title} duration={duration} location="Online" products={tags} courseId={courseId} />
        <Divider color={token('color.border')} />
        <LowerSection
          courseId={courseId}
          sessionId={session.id}
          sessionInfo={session}
          courseName={title}
          isEnrolled={isEnrolled}
          enrollmentId={enrollmentId}
          isFree={contentfulILTData?.free}
          hasConflict={false}
          otherSessions={otherSessions}
        />
        <Divider color={token('color.border')} />
        {isEnrolled && <EnrolledBanner {...enrollBanner} />}
      </div>
      <div css={contentContainerStyles}>
        <RichContent contentfulILTData={contentfulILTData} />
        <InstructorIntro instructor={contentfulILTData?.instructor} isFree={contentfulILTData?.free} />
      </div>
    </>
  );
};

const headerContainerStyles = css({
  display: 'flex',
  flexDirection: 'column',
  gap: token('space.400'),
  width: '100%',
  paddingBottom: token('space.400'),
});

const contentContainerStyles = css({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: token('space.400'),

  [media.above.sm]: {
    flexDirection: 'row',
    gap: token('space.300'),
  },
});
